export const TAB_TASKS_CLASS_TEACHER_EVENT = {
  action: 'Accede a la tab de tareas dentro de una clase',
  category: 'tab_tasks_teacher',
  event: 'click_tab_tasks_class_teacher',
  tag: 'click_tab',
}

export const OPEN_CREATE_TASK_TEACHER_EVENT = {
  action: 'Accede a la vista de crear una tarea',
  category: 'tab_tasks_teacher',
  event: 'click_open_create_task_teacher',
  tag: 'click_button',
}

export const CREATE_TASKS_TEACHER_EVENT = {
  action: 'Confirma la creación de la clase',
  category: 'view_tasks_teacher',
  event: 'click_create_tasks_teacher',
  tag: 'click_button',
}

export const CREATE_TASKS_TEACHER_FAILED_EVENT = {
  action: 'Captura el error cuando se crea una tarea',
  category: 'view_tasks_teacher',
  event: 'click_create_tasks_teacher_failed',
  tag: 'click_button',
}

export const OPEN_DETAILS_TASK_TEACHER_EVENT = {
  action: 'Abre la info de la tarea',
  category: 'menu_item_tasks_teacher',
  event: 'click_open_details_task_teacher',
  tag: 'click_menu_item',
}

export const OPEN_DELIVERY_TASKS_TEACHER_EVENT = {
  action: 'Abre las entregas de una tarea',
  category: 'menu_item_tasks_teacher',
  event: 'click_open_delivery_task_teacher',
  tag: 'click_menu_item',
}

export const CLOSE_TASK_TEACHER_EVENT = {
  action: 'Cierra la tarea',
  category: 'menu_item_tasks_teacher',
  event: 'click_close_task_teacher',
  tag: 'click_menu_item',
}

export const ACTIVE_TASK_TEACHER_EVENT = {
  action: 'Activa la tarea',
  category: 'menu_item_tasks_teacher',
  event: 'click_active_task_teacher',
  tag: 'click_menu_item',
}

export const DELETE_TASK_TEACHER_EVENT = {
  action: 'Elimina la tarea',
  category: 'menu_item_tasks_teacher',
  event: 'click_delete_task_teacher',
  tag: 'click_menu_item',
}

export const SEE_TASK_STUDENT_EVENT = {
  action: 'Abre la tarea',
  category: 'action_table_tasks_students',
  event: 'click_see_task_student',
  tag: 'click_button',
}
